import React from 'react';
import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './generalSettings.scss';
import ProfileNameCard from './NameCard/profileNameContainer';
import ProfileEmailCard from './EmailCard/profileEmailContainer';
import ProfilePasswordCard from './PasswordCard/profilePasswordContainer';
import ProfileLanguageCard from './LanguageCard/profileLanguageContainer';
import MFAStatus from './MFAStatusCard/mfaStatus';

class GeneralSettings extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            name: { firstName:'', lastName:'' },email: '',language:'',pendingEmail: '',
        };
        this.strings = getLocalizedStrings('GeneralSettings');
    }

    componentWillMount() {
        let ProfileData = !_.isEmpty(this.props.profileData) ? this.props.profileData : '';
        if(!_.isEmpty(ProfileData)){
            let updatedState = { ...this.state };
            updatedState.name.firstName = ProfileData.firstName;
            updatedState.name.lastName = ProfileData.lastName;
            updatedState.email = ProfileData.login;
            updatedState.language = ProfileData.preferredLanguage;
            let pendingEmailArray = !_.isEmpty(ProfileData.eixSCEpendingEmail) ? ProfileData.eixSCEpendingEmail.split(';') : [];  
            let changedEmail = (!_.isEmpty(pendingEmailArray) && pendingEmailArray[1]==='L') ? pendingEmailArray[3].split('::')[0] : '';
            updatedState.pendingEmail = changedEmail;
            this.setState({ ...updatedState });
        }
    }

    render(){
        const showMFACard = (drupalSettings.custom.globalInformation.setvals.mfa_card_value === undefined || drupalSettings.custom.globalInformation.setvals.mfa_card_value === '1');
        return(
            <div>
                <div className={classes.generalLabel}>{this.strings.generalLabel}</div>
                <div><ProfileNameCard profileName={this.state.name} email={this.state.email} /></div>
                <div className={classes.cardPadding}><ProfileEmailCard email={this.state.email} setVerficationError={this.props.setVerficationError} /></div>
                <div className={classes.cardPadding}><ProfilePasswordCard email={this.state.email} /></div>
                <div className={classes.cardPadding}><ProfileLanguageCard defaultLanguage={this.state.language} email={this.state.email} /></div>
                { showMFACard && <div className={classes.cardPadding}><MFAStatus /></div>}
            </div>
        );
    }
}

export default GeneralSettings;